const byName = (x, y) => (x || '').localeCompare(y || '', undefined, { sensitivity: 'base' });

// The date of the account's latest movement (ISO, so dates compare as text);
// empty for an account with none.
const lastDay = (account) => account.last_movement_date || '';

/**
 * The accounts in use first: the one with the latest movement leads, an
 * account with no movement comes last, and accounts that tie go A to Z.
 */
export function sortByRecentActivity(accounts) {
  return [...accounts].sort((a, b) => {
    if (lastDay(a) === lastDay(b)) return byName(a.name, b.name);
    return lastDay(a) < lastDay(b) ? 1 : -1;
  });
}
